import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import {PageWrapper} from 'components/PageWrapper';
import {InputText} from '../../../blocks/inputs/InputText';

@inject('clinicalNoteWritingCategoriesStore')
@observer
class CategoryForm extends PureComponent {
  handleChange = e => {
    const {clinicalNoteWritingCategoriesStore} = this.props;

    clinicalNoteWritingCategoriesStore.handleChange({[e.target.name]: e.target.value});
  };

  render() {
    const {clinicalNoteWritingCategoriesStore, submit} = this.props;
    const {category, errors} = clinicalNoteWritingCategoriesStore;
    const isNew = !category.id;

    return (
      <PageWrapper>
        <form className="simple-form" onSubmit={submit}>
          <h2>{isNew ? 'Add category' : 'Edit category'}</h2>
          <InputText
            label='Add a Title'
            placeholder='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={category.title}
            name='title'
            errorText={errors ? errors.title : ''}
          />
          <div className="row">
            <button className="btn-new-main" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to='/clinical-notes-writing' className="btn-new-white margin-left-20">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
}

export default CategoryForm;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/components/CategoryForm.js